"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Upsells/BroadcastsVerification.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _Page = require('web/components/Upsells/Page'); var _Page2 = _interopRequireDefault(_Page);








 const VERIFICATION_LOCKED_TITLE = 'Campaigns unlock once BloomText verifies your account'; exports.VERIFICATION_LOCKED_TITLE = VERIFICATION_LOCKED_TITLE
 const VERIFICATION_REQUESTED_HINT = "Request sent. We'll be in touch once your account is verified."; exports.VERIFICATION_REQUESTED_HINT = VERIFICATION_REQUESTED_HINT
 const VERIFICATION_ASK_ADMIN_HINT = 'Ask an admin on your account to request verification.'; exports.VERIFICATION_ASK_ADMIN_HINT = VERIFICATION_ASK_ADMIN_HINT
 const VERIFICATION_PAUSED_NOTICE = "Paused: campaigns can't send until BloomText verifies your account."; exports.VERIFICATION_PAUSED_NOTICE = VERIFICATION_PAUSED_NOTICE

 const verificationHint = (isAdmin, isRequested) => {
  if (isRequested) return exports.VERIFICATION_REQUESTED_HINT
  if (!isAdmin) return exports.VERIFICATION_ASK_ADMIN_HINT
  return ''
}; exports.verificationHint = verificationHint

const BroadcastsVerification = ({ isAdmin, isRequested, isRequesting, onRequest }) => (
  _react2.default.createElement(_Page2.default, {
    className: "upsells--video",
    title: exports.VERIFICATION_LOCKED_TITLE,
    desc: "New accounts are reviewed by our team before they can send campaigns. This protects your patients and every practice's ability to text. One-on-one texting works as usual in the meantime."                             ,
    hint: exports.verificationHint.call(void 0, isAdmin, isRequested),
    imgUrl: "assets/images/upsells/patients-illustration.png",
    onRequest: isAdmin && !isRequested ? onRequest : null,
    buttonLabel: "Request verification" ,
    isRequesting: isRequesting,
    showHintWithoutAction: true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 24}}
  )
)

exports. default = BroadcastsVerification
